import { render, staticRenderFns } from "./ProgramReservations.vue?vue&type=template&id=4bd3f103&"
import script from "./ProgramReservations.vue?vue&type=script&lang=js&"
export * from "./ProgramReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports